<div class="so">
	<mat-toolbar color="primary">
		<mat-toolbar-row class="headerStyle">
			<div class="col-md-4 col-sm-4 col-xs-4 imgStyle"><img src="../assets/images/ue-logo.png" class="logoImage"/></div>
			<span class="menu-spacer"></span>
			<div class="col-md-8 col-sm-8 col-xs-8 menu-list">
				
				
			</div>
		</mat-toolbar-row>
	</mat-toolbar>
	<div class="buttonBody" id="buttonBody">
		<div class="row buttonDiv headerCol col-sm-12">
			<div class="col-sm-6" nav1></div>
			<div class="col-sm-6" nav> 
				<span>
					<a style="cursor:default">{{userName}}</a>
				</span>
				<span>
					<a style="color:white;text-decoration:none;" (click)="logout()" class="logout-session">{{ 'Header.Logout' | translate }}</a>
				</span>
			</div>
		</div>
	</div>
</div>	
